import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "category"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "left-item-content"
};
const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "nav-bar-list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 0,
  class: "adsense"
};
const _hoisted_9 = ["src", "onClick"];
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = {
  class: "title-left"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "list"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "img-box"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "text"
};
const _hoisted_20 = {
  class: "category-list-pop-content"
};
const _hoisted_21 = {
  class: "pop-content-tit"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "pop-content-list"
};
const _hoisted_24 = ["onClick"];
import { ref, computed, nextTick, onMounted, onActivated } from 'vue';
import { useRouter, onBeforeRouteLeave } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import constants from '@/constants';
import { categoriesList } from '@/models/api/categoriesApi';
import { getSearchResult } from '@/models/api/detailPageApi';
import { useLess } from '@/models/hooks';
import { generateRandomString, jumpInteractionType } from '@/utils/common';
import { getWidget } from '@/utils/widgetCommon';
import imageLink from '@/configs/imageLink';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.beforeRouteEnterMethod();
    });
  }
});
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'Category',
  setup(__props, {
    expose: __expose
  }) {
    useLess('views/category/Category.less');
    const router = useRouter();
    const {
      t
    } = useI18n();
    const {
      ProductList
    } = constants;
    const store = useStore();
    const navHeight = computed(() => store.state.navigator.navHeight);
    const distanceFromTop = computed(() => {
      var _store$state$navigato, _store$state$navigato2;
      return (_store$state$navigato = (_store$state$navigato2 = store.state.navigator.agentData) === null || _store$state$navigato2 === void 0 ? void 0 : _store$state$navigato2.top) !== null && _store$state$navigato !== void 0 ? _store$state$navigato : 0;
    });
    const navHeightTotal = computed(() => {
      var _ref, _store$state$navigato3;
      return (_ref = `${Number(store.state.navigator.navHeight) + Number((_store$state$navigato3 = store.state.navigator.agentData) === null || _store$state$navigato3 === void 0 ? void 0 : _store$state$navigato3.top)}px`) !== null && _ref !== void 0 ? _ref : '0';
    });
    const tabbarHeight = computed(() => {
      var _ref2;
      return (_ref2 = `${store.state.common.tabbarHeight}px`) !== null && _ref2 !== void 0 ? _ref2 : 0;
    });
    const categoryList = ref([]);
    const active = ref(null);
    const itemActive = ref('');
    const isClickScroll = ref(false);
    const isShowNavPop = ref(false);
    const topCategoryRef = ref(null); // Top Category list Dom
    const navBarRef = ref(); // Secondary category nav Dom
    const navItemRef = ref([]); // Secondary category nav ItemList  Dom
    const scrollNavRef = ref(); // Secondary category nav scroll Dom
    const navItemModule = ref(); // Secondary and tertiary category Dom
    const navItemModuleList = ref([]); // Secondary and tertiary category ItemList Dom

    const {
      LOOP_TYPE,
      widgetInfo,
      getWidgetImage
    } = getWidget(constants.ADVERTISING_SOURCE_PAGE.CATEGORY, false);
    const getScrollTop = scroll => {
      return (scroll === null || scroll === void 0 ? void 0 : scroll.offsetTop) + (scroll === null || scroll === void 0 ? void 0 : scroll.clientTop) || 0;
    };
    // vertical scrolling of secondary category floor navigation
    const floorScrollTo = index => {
      var _navItemModuleList$va, _navBarRef$value;
      const scrollTop = getScrollTop((_navItemModuleList$va = navItemModuleList.value) === null || _navItemModuleList$va === void 0 ? void 0 : _navItemModuleList$va[index]);
      const distanceTop = (_navBarRef$value = navBarRef.value) === null || _navBarRef$value === void 0 ? void 0 : _navBarRef$value.offsetHeight;
      navItemModule.value.scrollTo(0, scrollTop - distanceTop);
    };
    // Horizontal scrolling of secondary floor navigation
    const navScrollTo = (childElement, index) => {
      scrollNavRef.value.scrollTo({
        left: childElement.clientWidth * index,
        behavior: 'smooth'
      });
    };
    const getCategoryImage = () => {
      var _active$value$subMenu, _active$value$subMenu2, _active$value$subMenu3, _active$value$subMenu4;
      if ((_active$value$subMenu = active.value.subMenu) !== null && _active$value$subMenu !== void 0 && (_active$value$subMenu2 = _active$value$subMenu[0]) !== null && _active$value$subMenu2 !== void 0 && (_active$value$subMenu3 = _active$value$subMenu2.subMenu) !== null && _active$value$subMenu3 !== void 0 && (_active$value$subMenu4 = _active$value$subMenu3[0]) !== null && _active$value$subMenu4 !== void 0 && _active$value$subMenu4.image) return;
      active.value.subMenu.forEach(second => {
        second.subMenu.forEach(async third => {
          if (third !== null && third !== void 0 && third.categoryImgUrl) {
            third.image = third === null || third === void 0 ? void 0 : third.categoryImgUrl;
          } else {
            try {
              var _searchResult$asinLis;
              const {
                data: searchResult
              } = await getSearchResult({
                corp: false,
                imageResolution: ProductList.IMAGE_RESOLUTION,
                refinementRequestList: [{
                  id: ProductList.TOP_CATEGORY_ID,
                  value: third === null || third === void 0 ? void 0 : third.usNodeId
                }],
                pageIndex: 1,
                size: ProductList.ASINS_QUANTITY_THRESHOLD_PER_PAGE,
                requestId: generateRandomString(constants.ORDER_EXTERNAL_REQUEST_ID_LENGTH),
                sort: ProductList.DATA_SORT,
                withCache: false
              });
              third.image = searchResult === null || searchResult === void 0 ? void 0 : (_searchResult$asinLis = searchResult.asinList[0]) === null || _searchResult$asinLis === void 0 ? void 0 : _searchResult$asinLis.mainImage;
            } catch (error) {
              console.error(error, 'api---error---getSearchResult');
            }
          }
        });
      });
    };
    const jumpToPage = picInfo => {
      jumpInteractionType(picInfo, router);
    };
    const handleClickSecondary = (item, index, close) => {
      var _navItemRef$value;
      if (close) isShowNavPop.value = false;
      itemActive.value = item.categoryName;
      floorScrollTo(index);
      const childElement = (_navItemRef$value = navItemRef.value) === null || _navItemRef$value === void 0 ? void 0 : _navItemRef$value[index];
      navScrollTo(childElement, index);
      isClickScroll.value = true;
      setTimeout(() => {
        isClickScroll.value = false;
      }, 10);
    };
    const floorHandleScroll = () => {
      if (isClickScroll.value) return;
      for (let i = 0; i < navItemModuleList.value.length; i++) {
        var _navItemModuleList$va2, _scrollNavRef$value, _navItemModule$value;
        const section = (_navItemModuleList$va2 = navItemModuleList.value) === null || _navItemModuleList$va2 === void 0 ? void 0 : _navItemModuleList$va2[i];
        const offsetTop = getScrollTop(section);
        const distanceTop = ((_scrollNavRef$value = scrollNavRef.value) === null || _scrollNavRef$value === void 0 ? void 0 : _scrollNavRef$value.offsetHeight) + Number(navHeight.value) + Number(distanceFromTop.value);
        const scrollTop = (_navItemModule$value = navItemModule.value) === null || _navItemModule$value === void 0 ? void 0 : _navItemModule$value.scrollTop;
        if (offsetTop - distanceTop <= scrollTop && offsetTop + section.offsetHeight > scrollTop) {
          var _navItemRef$value2;
          if (scrollTop < section.offsetHeight) {
            var _active$value, _active$value$subMenu5;
            itemActive.value = (_active$value = active.value) === null || _active$value === void 0 ? void 0 : (_active$value$subMenu5 = _active$value.subMenu[0]) === null || _active$value$subMenu5 === void 0 ? void 0 : _active$value$subMenu5.categoryName;
          } else {
            var _active$value2, _active$value2$subMen, _active$value2$subMen2;
            itemActive.value = (_active$value2 = active.value) === null || _active$value2 === void 0 ? void 0 : (_active$value2$subMen = _active$value2.subMenu) === null || _active$value2$subMen === void 0 ? void 0 : (_active$value2$subMen2 = _active$value2$subMen[i]) === null || _active$value2$subMen2 === void 0 ? void 0 : _active$value2$subMen2.categoryName;
          }
          const childElement = (_navItemRef$value2 = navItemRef.value) === null || _navItemRef$value2 === void 0 ? void 0 : _navItemRef$value2[i];
          navScrollTo(childElement);
        }
      }
    };
    const handleClickItem = async (item, index) => {
      var _active$value$subMenu6, _active$value3, _active$value3$subMen;
      isShowNavPop.value = false;
      active.value = item;
      getCategoryImage();
      getWidgetImage(`${active.value.marketplaceIdLanguage}_${active.value.categoryName}`);
      itemActive.value = (_active$value$subMenu6 = (_active$value3 = active.value) === null || _active$value3 === void 0 ? void 0 : (_active$value3$subMen = _active$value3.subMenu[0]) === null || _active$value3$subMen === void 0 ? void 0 : _active$value3$subMen.categoryName) !== null && _active$value$subMenu6 !== void 0 ? _active$value$subMenu6 : '';
      nextTick(() => {
        var _topCategoryRef$value, _topCategoryRef$value2;
        navItemModule.value.scrollTop = 0;
        scrollNavRef.value.scrollLeft = 0;
        (_topCategoryRef$value = topCategoryRef.value) === null || _topCategoryRef$value === void 0 ? void 0 : (_topCategoryRef$value2 = _topCategoryRef$value.children[index]) === null || _topCategoryRef$value2 === void 0 ? void 0 : _topCategoryRef$value2.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    };
    const handleOpen = () => {
      isShowNavPop.value = true;
    };
    const handleRouteToProductList = (value, title) => {
      router.push({
        name: 'productList',
        params: {
          keyword: JSON.stringify({
            value,
            id: 'n'
          }),
          type: 'fromCategory'
        },
        query: {
          title
        }
      });
    };
    let previousScrollPosition = 0;
    let previousLeftScrollPosition = 0;
    onBeforeRouteLeave(() => {
      previousScrollPosition = navItemModule.value.scrollTop;
      previousLeftScrollPosition = topCategoryRef.value.scrollTop;
    });
    const beforeRouteEnterMethod = () => {
      navItemModule.value.scrollTop = previousScrollPosition;
      topCategoryRef.value.scrollTop = previousLeftScrollPosition;
    };
    onMounted(async () => {
      try {
        var _active$value$subMenu7, _active$value4, _active$value4$subMen;
        const {
          data: {
            data
          }
        } = await categoriesList({
          language: constants.ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[constants.ENCRYPTED_MARKETPLACE_ID]
        });
        categoryList.value = data;
        active.value = categoryList.value[0];
        getWidgetImage(`${active.value.marketplaceIdLanguage}_${active.value.categoryName}`);
        getCategoryImage();
        itemActive.value = (_active$value$subMenu7 = (_active$value4 = active.value) === null || _active$value4 === void 0 ? void 0 : (_active$value4$subMen = _active$value4.subMenu[0]) === null || _active$value4$subMen === void 0 ? void 0 : _active$value4$subMen.categoryName) !== null && _active$value$subMenu7 !== void 0 ? _active$value$subMenu7 : '';
      } catch (error) {
        console.error(error, 'api---error---categoriesList');
      }
    });
    onActivated(async () => {
      const navDom = document.querySelector('.nav-wrapper');
      await nextTick();
      nextTick(() => {
        store.commit('navigator/setNavHeight', navDom === null || navDom === void 0 ? void 0 : navDom.clientHeight);
      });
    });
    __expose({
      beforeRouteEnterMethod
    });
    return (_ctx, _cache) => {
      var _active$value6, _active$value7, _active$value8;
      const _component_amz_nav = _resolveComponent("amz-nav");
      const _component_van_swipe_item = _resolveComponent("van-swipe-item");
      const _component_van_swipe = _resolveComponent("van-swipe");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_amz_nav, {
        title: _unref(t)('modules.category.CATEGORY'),
        class: "nav",
        isBack: false
      }, null, 8, ["title"]), _createElementVNode("div", {
        class: "left",
        ref_key: "topCategoryRef",
        ref: topCategoryRef,
        style: _normalizeStyle({
          paddingBottom: tabbarHeight.value
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, (item, index) => {
        var _active$value5;
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["left-item", {
            active: item.categoryName === ((_active$value5 = active.value) === null || _active$value5 === void 0 ? void 0 : _active$value5.categoryName)
          }]),
          key: item.categoryName,
          onClick: $event => handleClickItem(item, index)
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.categoryName), 1)])], 10, _hoisted_2);
      }), 128))], 4), _createElementVNode("div", {
        class: "right",
        style: _normalizeStyle({
          paddingBottom: tabbarHeight.value
        })
      }, [_withDirectives(_createElementVNode("div", {
        class: "nav-bar",
        ref_key: "navBarRef",
        ref: navBarRef
      }, [_createElementVNode("span", {
        class: "nav-expandss",
        onClick: handleOpen
      }, [_createElementVNode("img", {
        src: `${_unref(constants).IMAGE_URL}assets/svg/categoryPopArrow.svg`,
        alt: ""
      }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "scroll-view",
        ref_key: "scrollNavRef",
        ref: scrollNavRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_active$value6 = active.value) === null || _active$value6 === void 0 ? void 0 : _active$value6.subMenu, (secondItem, secondIndex) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["nav-bar-item", {
            active: secondItem.categoryName === itemActive.value
          }]),
          key: secondItem.categoryName,
          ref_for: true,
          ref: item => navItemRef.value[secondIndex] = item,
          onClick: $event => handleClickSecondary(secondItem, secondIndex)
        }, _toDisplayString(secondItem.categoryName), 11, _hoisted_7);
      }), 128))], 512)])], 512), [[_vShow, (_active$value7 = active.value) === null || _active$value7 === void 0 ? void 0 : _active$value7.hasSecondaryTotal]]), _createElementVNode("div", {
        class: "floor-box",
        ref_key: "navItemModule",
        ref: navItemModule,
        onScroll: _cache[0] || (_cache[0] = e => floorHandleScroll(e))
      }, [_unref(widgetInfo) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_van_swipe, {
        class: "my-swipe",
        loop: _unref(widgetInfo).slitherType === _unref(LOOP_TYPE).AUTO,
        autoplay: _unref(widgetInfo).slitherTime * 1000
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(widgetInfo).picInfo, image => {
          return _openBlock(), _createBlock(_component_van_swipe_item, {
            key: image
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              src: image.pic,
              onClick: $event => jumpToPage(image)
            }, null, 8, _hoisted_9)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["loop", "autoplay"])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_active$value8 = active.value) === null || _active$value8 === void 0 ? void 0 : _active$value8.subMenu, (secondItem, secondIndex) => {
        var _active$value9;
        return _openBlock(), _createElementBlock("div", {
          class: "nav-floor",
          key: secondItem.categoryName,
          ref_for: true,
          ref: item => navItemModuleList.value[secondIndex] = item
        }, [_withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(secondItem.categoryName), 1), _createElementVNode("div", {
          class: "title-right",
          onClick: $event => handleRouteToProductList(secondItem.usNodeId, secondItem.categoryName)
        }, [_createElementVNode("span", null, _toDisplayString(_unref(t)('modules.category.ALL')), 1), _createElementVNode("img", {
          src: `${_unref(constants).IMAGE_URL}assets/svg/categoryRightArrow.svg`,
          alt: ""
        }, null, 8, _hoisted_13)], 8, _hoisted_12)], 512), [[_vShow, (_active$value9 = active.value) === null || _active$value9 === void 0 ? void 0 : _active$value9.hasSecondaryTotal]]), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondItem.subMenu, thirdItem => {
          return _openBlock(), _createElementBlock("div", {
            class: "list-item",
            key: thirdItem.categoryName,
            onClick: $event => handleRouteToProductList(thirdItem.usNodeId, thirdItem.categoryName)
          }, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_van_image, {
            src: thirdItem.image
          }, {
            loading: _withCtx(() => [_createElementVNode("img", {
              src: _unref(imageLink).NO_DATA_IMAGE,
              alt: "NO_DATA_IMAGE"
            }, null, 8, _hoisted_17)]),
            error: _withCtx(() => [_createElementVNode("img", {
              src: _unref(imageLink).NO_DATA_IMAGE,
              alt: "NO_DATA_IMAGE"
            }, null, 8, _hoisted_18)]),
            _: 2
          }, 1032, ["src"])]), _createElementVNode("div", _hoisted_19, _toDisplayString(thirdItem.categoryName), 1)], 8, _hoisted_15);
        }), 128))])]);
      }), 128))], 544)], 4), _createVNode(_component_van_popup, {
        "z-index": "100",
        "overlay-class": "a-overlay category-overlay",
        show: isShowNavPop.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => isShowNavPop.value = $event),
        position: "top",
        "overlay-style": {
          top: navHeightTotal.value
        },
        class: "category-popup"
      }, {
        default: _withCtx(() => {
          var _active$value10;
          return [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("span", null, _toDisplayString(active.value.categoryName), 1), _createElementVNode("div", {
            class: "put-away",
            onClick: _cache[1] || (_cache[1] = () => isShowNavPop.value = false)
          }, [_createElementVNode("img", {
            src: `${_unref(constants).IMAGE_URL}assets/svg/categoryPopArrow.svg`,
            alt: ""
          }, null, 8, _hoisted_22)])]), _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_active$value10 = active.value) === null || _active$value10 === void 0 ? void 0 : _active$value10.subMenu, (secondItem, secondIndex) => {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["pop-content-item", {
                active: secondItem.categoryName === itemActive.value
              }]),
              key: secondItem.categoryName,
              onClick: $event => handleClickSecondary(secondItem, secondIndex, 'close')
            }, _toDisplayString(secondItem.categoryName), 11, _hoisted_24);
          }), 128))])])];
        }),
        _: 1
      }, 8, ["show", "overlay-style"])]);
    };
  }
});